import App from './App';
import AppLessonsOnly from './AppLessonsOnly';
// Each router owns its namespace; existing Telegram root/lesson links remain valid.
export default function Application(){
 const path=window.location.pathname;
 return path==='/platform-admin'||path.startsWith('/platform-admin/')?<App/>:<AppLessonsOnly/>;
}
